import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class GDVService extends CRUDService{
    constructor() {
        super("gdv");
    }

    findByCargoEmpresaGlobo(cargoId, empresaGloboId) {
        return http.get("/"+this.serviceName+"/"+cargoId+"/"+empresaGloboId);
    }
}